import coupons from '@/api/coupons';

const SET_COUPONS = 'SET_COUPONS';
const APPEND_COUPONS = 'APPEND_COUPONS';
const PREPEND_COUPON = 'PREPEND_COUPON';
const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_ALL = 'SET_IS_ALL';
const ADD_PAGE = 'ADD_PAGE';
const RESET_COUPONS = 'RESET_COUPONS';
const DELETE = 'DELETE';
const UPDATE = 'UPDATE';
const UPDATE_STATUS = 'UPDATE_STATUS';

const state = {
	all: [],
	isFetching: false,
	isAll: false,
	page: 1,
};

const getters = {
	allCoupons: state => state.all,
	isFetching: state => state.isFetching,
	isAll: state => state.isAll,
	page: state => state.page,
};

const mutations = {
	[SET_COUPONS](state, coupons) {
		state.all = coupons;
	},
	[APPEND_COUPONS](state, coupons) {
		state.all = state.all.concat(coupons);
	},
	[PREPEND_COUPON](state, coupon) {
		state.all.unshift(coupon);
	},
	[RESET_COUPONS](state) {
		state.all = [];
		state.isAll = false;
		state.page = 1;
	},
	[DELETE](state, index) {
		state.all.splice(index, 1);
	},
	[UPDATE](state, couponData) {
		const index = state.all.findIndex(item => item._id === couponData._id);
		if (index !== -1) {
			state.all[index] = couponData;
		}
	},
	[UPDATE_STATUS](state, couponData) {
		const ids = couponData.ids;
		const status = couponData.status;
		for (let index = 0; index < ids.length; index++) {
			const id = ids[index];
			const couponIndex = state.all.findIndex(curr => curr._id === id);
			if (couponIndex !== -1) {
				const isActive = status === 1 || status === '1';
				state.all[couponIndex].is_active = isActive;
			}
		}
	},
	[SET_IS_FETCHING](state, status) {
		state.isFetching = status;
	},
	[SET_IS_ALL](state, status) {
		state.isAll = status;
	},
	[ADD_PAGE](state) {
		state.page++;
	},
};

const actions = {
	getCoupons({ commit, getters }, params) {
		if (!getters.isFetching) {
			commit(SET_IS_FETCHING, true);
			const callback = (response) => {
				const coupons = response.data;
				if (coupons.length !== 0) {
					commit(APPEND_COUPONS, coupons);
					commit(ADD_PAGE);
				} else {
					commit(SET_IS_ALL, true);
				}
				commit(SET_IS_FETCHING, false);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
			};
			coupons.getCoupons(params, callback, errorCallback);
		}
	},
	resetCoupons({ commit }) {
		commit(RESET_COUPONS);
	},
	prepend({ commit }, payload) {
		commit(PREPEND_COUPON, payload);
	},
	delete({ commit }, index) {
		commit(DELETE, index);
	},
	update({ commit }, payload) {
		commit(UPDATE, payload);
	},
	updateStatus({ commit }, payload) {
		commit(UPDATE_STATUS, payload);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
